import React, { Fragment } from 'react';
import { bool, shape, string } from 'prop-types';
import { compose, setDisplayName, getContext } from 'react-recompose';
import { FormSection, formValueSelector } from 'redux-form/immutable';

import withReduxConnect from '~/views/enhancers/withReduxConnect';

import { required, numericality, length } from 'redux-form-validators';
import { Form, Checkbox, Input } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';


export const AddressFormComponent = ({ isAddressRequired }) => (
    <Section name="Address">
        <Form.Group>
            <FormField name="unknown" label="Unknown" control={Checkbox} />
            <FormField name="virtual" label="Virtual" control={Checkbox} />
        </Form.Group>

        { isAddressRequired && (
            <Fragment>
                <Form.Group>
                    <FormField
                        name="street"
                        label="Street"
                        placeholder="Street"
                        control={Input}
                        validate={[required(), length({ min: 4 })]}
                        required
                        width={12}
                    />

                    <FormField
                        name="postal"
                        label="Postal"
                        placeholder="Postal"
                        control={Input}
                        validate={[numericality(), length({ min: 5 }), length({ max: 25 })]}
                        required
                        width={4}
                    />
                </Form.Group>

                <Form.Group>
                    <FormField
                        name="street2"
                        label="Street 2"
                        placeholder="Street 2"
                        control={Input}
                        width={12}
                    />
                </Form.Group>

                <Form.Group>
                    <FormField
                        name="city"
                        label="City"
                        placeholder="City"
                        control={Input}
                        validate={required()}
                        required
                        width={6}
                    />

                    <FormField
                        name="county"
                        label="County"
                        placeholder="County"
                        control={Input}
                        width={4}
                    />
                    <FormField
                        name="state"
                        label="State"
                        placeholder="State"
                        control={Input}
                        width={2}
                        validate={[length({ max: 3 })]}
                    />
                    <FormField
                        name="country"
                        label="Country"
                        placeholder="Country"
                        control={Input}
                        width={4}
                        validate={[length({ min: 2, allowBlank: true }), length({ max: 2 })]}
                    />
                </Form.Group>

                <Form.Group>
                    <FormField
                        name="latitude"
                        label="Latitude"
                        placeholder="Latitude"
                        control={Input}
                        validate={numericality({
                            if: (_, value) => value,
                        })}
                    />

                    <FormField
                        name="longitude"
                        label="Longitude"
                        placeholder="Longitude"
                        control={Input}
                        validate={numericality({
                            if: (_, value) => value,
                        })}
                    />
                </Form.Group>
            </Fragment>
        ) }
    </Section>
);

AddressFormComponent.propTypes = {
    isAddressRequired: bool.isRequired,
};

const withReduxFormSection = Component => props => (
    <FormSection name="address">
        <Component {...props} />
    </FormSection>
);

export default compose(
    setDisplayName('AddressFormContainer'),
    getContext({
        _reduxForm: shape({
            form: string.isRequired,
        }).isRequired,
    }),
    withReduxConnect({
        mapStateToProps: (state, { _reduxForm }) => {
            if (!_reduxForm || !_reduxForm.form) {
                return {
                    isAddressRequired: true,
                };
            }
            const form = _reduxForm.form;
            const valueSelector = formValueSelector(form);
            const isAddressUnknown = valueSelector(state, 'address.unknown');
            const isAddressVirtual = valueSelector(state, 'address.virtual');

            return {
                isAddressRequired: !(isAddressUnknown || isAddressVirtual),
            };
        },
    }),
    withReduxFormSection,
)(AddressFormComponent);
